import ViolationsTabGraph from './ViolationsTabGraph';

export default ViolationsTabGraph;
